export default __webpack_public_path__ + "static/media/laura.46af37c5.jpg";